// extracted by mini-css-extract-plugin
export default {"chartOne":"Chart_chartOne__STFDQ","chartThree":"Chart_chartThree__YxBe9"};